export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_19-EN-5f54abc0166e959023f1de4d58981f59.webp";